import React,{useState,useEffect} from 'react';
import { toast } from 'react-toastify';
import Loading from '~/components/loading/loading';
import { apiLocal, apiRaw } from '~/services/api';
import { DivInfo } from './styledConfirmaConsultaWhats';
import dayjs from 'dayjs';
import { Button } from '~/styles/CommonStyles';
import {Link,NavLink,Redirect} from 'react-router-dom';


export default function ConfirmaConsultaWhats({location}) {
    const params =  new URLSearchParams( location.search );
    const paramsAgendamento = { e:params.get( 'e' ),chave:params.get('chave')}
    const [dadosAgendamento, setDadosAgendamento ] = useState(null)
    const [display, setDisplay] = useState("none");

    useEffect(()=>{
        init()
    },[])


    async function getInformacoesConsulta(){
        try {
            const responseConfirmaConsulta = await apiLocal.post(`whatsapp/GetDadosAgendamento`,paramsAgendamento);
            if(responseConfirmaConsulta.status == 200){
                return responseConfirmaConsulta.data
            }else{
                toast.error('Erro ao tentar confirmar agendamento.')
            }
        } catch (error) {
            console.error(error);
            toast.error('Não foi possível confirmar agendamento.')
        }
    };

    async function init(){
        setDisplay("flex")
        try {
            const dados = await getInformacoesConsulta()
            setDadosAgendamento(dados)
        } catch (error) {
            console.error(error);
            toast.error('Error na inicialização da página.')
        }
        setDisplay("none")
    };
    
    function redirecionar(confirmacao){
        return <Redirect to={{pathname:`confirma`,search:`?e=${paramsAgendamento.e}&chave=${paramsAgendamento.chave}&c=${confirmacao}`}}></Redirect>
    }

  return(
    <div style={{display:"flex",flexDirection:"column",alignItems:'center'}}>
        <div style={{marginTop:'8px',marginBottom:'8px'}}>
            <h1>Informações do agendamento</h1> 
        </div>
        <div>
            <DivInfo>
                <div style={{marginRight:'8px'}}>Data</div>
                <div style={{fontWeight:'bolder'}}>{dadosAgendamento?.Inicio? dayjs(dadosAgendamento.Inicio).format('DD/MM/YYYY HH:mm'):'' }</div>
            </DivInfo>
            {
                dadosAgendamento?.Usuario?
                    (
                        <DivInfo>
                            <div style={{marginRight:'8px'}}>Profissional</div>
                            <div style={{fontWeight:'bolder'}}>{dadosAgendamento?.Usuario??'' }</div>
                        </DivInfo>
                    ) 
                : 
                    ''
            }
            
            <DivInfo>
                <Link to={{pathname:`confirma`,search:`?e=${encodeURIComponent(paramsAgendamento.e)}&chave=${encodeURIComponent(paramsAgendamento.chave)}&c=false`}}>
                    <Button onClick={()=>redirecionar(true)} style={{marginRight:'8px',background:'#d52323'}}>Cancelar</Button>
                </Link>
                <Link style={{texDecoration:'none'}} to={{pathname:`confirma`,search:`?e=${encodeURIComponent(paramsAgendamento.e)}&chave=${encodeURIComponent(paramsAgendamento.chave)}&c=true`}}>
                    <Button style={{background:'green'}}>Confirmar</Button>
                </Link>
            </DivInfo>
        </div>
        <Loading mostrar={display} />
    </div>
  ) 
  
}